import DarkBgCardsFrame from "@/components/darkBgCards";
import { OFFERINGS_CONSTANTS } from "./constants";

const OfferingsComp = () => {
  return (
    <DarkBgCardsFrame
      {...OFFERINGS_CONSTANTS}
      columns={{ base: 1, sm: 2, md: 4 }}
      spacing={{ base: 4, md: 8 }}
    />
  );
};

export default OfferingsComp;
